export const spacing = (size: number): string => {
  return size * 6 + "px";
};

export const radius = (size: number): string => {
  return size * 4 + "px";
};

export const hexToRgba = (hex: string, opacity: number) => {
  var bigint = parseInt(hex, 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;

  return r + "," + g + "," + b + "," + opacity;
};


export const MOBILE_WIDTH = "1000px";

export const COLOR_LIGHT_GRAY = "#D4D4D4";

export const COLOR_DARK_GRAY = "#707275";

export const COLOR_PLACEHOLDER = "#B8B8B8";

export const COLOR_TEXT = "#1A1C23";

export const COLOR_ERROR = "#EF5350";

export const COLOR_ERROR_LIGHT = "#E57373";

export const COLOR_ADEGA_BLUE = "#192a58";

export const COLOR_OUT_BORDER = "#d5d6d7";

export const COLOR_ADEGA_BLUE_HEX = "4285F4";

export const COLOR_ADEGA_RED = "#9E2A2C";

export const COLOR_ADEGA_RED_HEX = "DB4437";

export const COLOR_BACKGROUND = "#f0f0f0";

export const COLOR_ELEVATION_01 = "#fff";

export const COLOR_DASHBOARD_BACKGROUND = "#F9FAFB";

export const COLOR_DASHBOARD_ELEVATION_01 = "#FFFFFF";

export const COLOR_DISABLED = "#EAEAEA"
